import { generateClient } from 'aws-amplify/api';
import FormSelectInput from "./FormSelectInput";
import { searchCustomers } from "../common/graphql/queries";
import { useEffect, useState } from 'react';

const client = generateClient();

let runningPromise = {};
const FormSelectCustomer = (props) => {
    const [defaultOptions, setOptions] = useState([]);

    useEffect(() => {
        (async () => {
            const options = await loadOptions("");
            setOptions(options);
        })()
    }, [props.locationId])

    const loadOptions = async (input) => {
        try {
            if (runningPromise[props.name]) client.cancel(runningPromise[props.name], "cancelled");
            runningPromise[props.name] = client.graphql({
                query: searchCustomers,
                variables: {
                    filter: {
                        active: { eq: true },
                        locationId: {
                            eq: props.locationId,
                        },
                        name: {
                            wildcard: `*${input}*`,
                        },
                    },
                    sort: { direction: "asc", field: "name" },
                    limit: 25,
                },
            })

            const { data: { searchCustomers: { items } } } = await runningPromise[props.name];

            return items.map(cx => ({ value: cx.id, label: cx.name }))
        } catch (ex) {
            return [];
        }
    }

    return (
        <FormSelectInput loadOptions={loadOptions} defaultOptions={defaultOptions} {...props} />
    )
}

export default FormSelectCustomer;